import React from 'react'
import { Modal, ModalProps } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

interface CustomModalProps extends Omit<ModalProps, 'open' | 'onCancel'> {
    isOpen: boolean
    onClose: () => void
    closable?: boolean
    maskClosable?: boolean
}

const ModalWrapper: React.FC<CustomModalProps> = ({
    isOpen,
    onClose,
    width,
    className,
    children,
    closable = true,
    maskClosable = true,
}) => (
    <Modal
        open={isOpen}
        onCancel={onClose}
        width={width}
        footer={null}
        className={className ?? 'default-modal'}
        closeIcon={<CloseOutlined />}
        centered
        closable={closable}
        maskClosable={maskClosable}
    >
        {children}
    </Modal>
)

export default ModalWrapper
